<template>
    <div
        v-if="hasFeature(featureName) && hasAnyPermission(permissionName)"
        :class="!isMobile ? 'p-1' : ''"
        class="h-fit flex-col rounded-xl bg-white"
    >
        <tooltip-wrapper :enabled="isEnabled" :tooltip="tooltipText">
            <component :is="iconComponent" v-if="!isMobile && iconComponent" class="m-auto my-2 h-11 justify-self-center" />
            <div>
                <modal-link
                    :id="buttonId"
                    :disabled="isEnabled"
                    :href="href"
                    class="btn btn-secondary !border-0 !bg-button-primary !font-bold"
                    @created="$emit('created', $event)"
                >
                    <span class="truncate">{{ buttonLabel }}</span>
                </modal-link>
            </div>
        </tooltip-wrapper>
    </div>
</template>

<script setup>
import TooltipWrapper from '@/Pages/Assets/Details/TooltipWrapper.vue';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';
import { hasFeature } from '@/mixins/hasFeature.js';
import { isMobile } from '@/Utils/UseMedia.js';

defineProps({
    isEnabled: {
        type: Boolean,
        required: true,
    },
    iconComponent: {
        type: Object,
        default: null,
    },
    featureName: {
        type: String,
        required: true,
    },
    permissionName: {
        type: [String, Array],
        required: true,
    },
    href: {
        type: String,
        required: true,
    },
    buttonLabel: {
        type: String,
        required: true,
    },
    tooltipText: {
        type: String,
        required: true,
    },
    buttonId: {
        type: String,
        default: '',
    },
});

defineEmits(['created']);
</script>
